import { render, staticRenderFns } from "./ProductPDF.vue?vue&type=template&id=0f5ce747&scoped=true"
import script from "./ProductPDF.vue?vue&type=script&lang=js"
export * from "./ProductPDF.vue?vue&type=script&lang=js"
import style0 from "./ProductPDF.vue?vue&type=style&index=0&id=0f5ce747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ce747",
  null
  
)

export default component.exports